<script setup lang="ts">
import { LineupModel } from '@collector/desktop-feature-lineups'
import { runLoader, useConfirmModal } from '@collector/shared-ui'
import { Participant } from '@collector/sportsapi-types'
import { useEvent } from '@desktop/views/Relation/composables'
import BaseLineupsModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/BaseLineupsModal/BaseLineupsModal.vue'
import NoCoachConfirmModal from '@desktop/views/Relation/Sports/components/RelationView/Main/MainSummary/Lineups/ConfirmModals/NoCoachConfirmModal.vue'
import { UpdateLineupsFn } from '@desktop/views/Relation/Sports/composables'

interface Props {
  participant: Participant
}
const props = defineProps<Props>()

const { openModalForConfirm } = useConfirmModal()
const { event } = useEvent()

// methods
async function confirmUpdateLineup(
  lineup: LineupModel,
  _initialLineup: LineupModel,
  updateLineups: UpdateLineupsFn,
): Promise<void> {
  const coachCount = lineup.coach.length

  if (coachCount === 0) await openModalForConfirm(NoCoachConfirmModal)

  await runLoader(updateLineups(event.value.id, props.participant.id, lineup))
}
</script>

<template>
  <BaseLineupsModal
    :participant
    :confirmUpdateLineup
  />
</template>
